// -------------
// this is the registration of all default rule elements
// -------------
export class RegisterRuleElements {
    static isRegistered = false;

    static doRegistration() {
        if (RegisterRuleElements.isRegistered) return;

        RegisterRuleElements.isRegistered = true;
    }
}
